export const NTAQuestionType = {
    Radio: 'product_builder_element_radio',
    Checkbox: 'product_builder_element_checkbox',
    Text: 'product_builder_element_text'
}
